import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { gql } from 'graphql-request'
import { gqlClient } from '@/lib/graphql'

export interface GithubRepo {
  name: string
  fullName: string
  description: string | null
  pushedAt: string | null
}

const REPOS = gql`
  query GithubRepos {
    githubRepos {
      name
      fullName
      description
      pushedAt
    }
  }
`

// Fetched lazily — only when the import dialog is open (`enabled`).
export function useGithubRepos(enabled: boolean) {
  return useQuery({
    queryKey: ['github-repos'],
    enabled,
    staleTime: 60_000,
    queryFn: async () => (await gqlClient.request<{ githubRepos: GithubRepo[] }>(REPOS)).githubRepos,
  })
}

const IMPORT = gql`
  mutation ImportBookFromGithub($repoName: String!) {
    importBookFromGithub(input: { repoName: $repoName }) {
      book { slug status }
      errors
    }
  }
`

interface ImportResult {
  importBookFromGithub: {
    book: { slug: string; status: string } | null
    errors: string[]
  }
}

export function useImportBook() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (repoName: string) => {
      const res = await gqlClient.request<ImportResult>(IMPORT, { repoName })
      if (res.importBookFromGithub.errors.length) {
        throw new Error(res.importBookFromGithub.errors.join(', '))
      }
      return res.importBookFromGithub.book
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['books'] }),
  })
}
